/** SVG viewBox dimensions and CSS display sizes. */
export const SIZES = {
  SMALL: 30,
  DEFAULT: 128,
} as const

/** Holographic background image dimensions and responsive breakpoint. */
export const HOLO_WIDTH = 1536
export const HOLO_HEIGHT = 1024
export const MD_BREAKPOINT = 768

export const HOLO_IMAGE_PATH = '/img/product/verified-refurbished/holo.avif'
